const config = {
  carbonCopyTypeList: [{ name: '指定人员', value: 1 }, { name: '指定部门', value: 2 }, { name: '指定角色', value: 3 }, { name: '部门主管', value: 4 }, { name: '直属主管', value: 5 }],
  auditOrderMap: [{ name: '前加签', value: 1 }, { name: '后加签', value: 2 }]
};
export { config };
